var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIconPerp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#A0EE09",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 25.0555H18.375V33.5C15.5625 33.5 15 31.8915 15 31.0873V25.0555Z",
    fill: "#79B116"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 15.5V32.5C33 33.0522 32.5523 33.5 32 33.5H18.375V15.5C18.375 14.9477 18.8227 14.5 19.375 14.5H32C32.5523 14.5 33 14.9477 33 15.5ZM20.6249 29.2776H30.7499V31.3887H20.6249V29.2776ZM30.75 16.6111H21.75L25.5341 20.1616L20.6249 24.7678L22.0567 26.1112L26.9659 21.5051L30.75 25.0556V16.6111Z",
    fill: "#A0EE09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconPerp);
export default __webpack_public_path__ + "static/media/menu-icon-perp.a84f6be2f8f5908768c827e74c692b84.svg";
export { ForwardRef as ReactComponent };